import PropTypes from 'prop-types'
import React from 'react'

import CsvDownloadLink from 'components/CsvDownloadLink'
import FileUpload from 'components/FileUpload/FileUpload'
import Loading from 'components/Loading/Loading'
import {
  FieldDescriptions,
  InstructionsText,
  TitleSection,
} from '../../../components/Pacing/SectionFields'
import { csvTemplateHeaders, errorsHeaders, resultsHeaders } from './data.js'
import {
  ExampleImage,
  Instructions,
  ResultsSection,
  StyledAutoTable,
  TemplateLinkWrapper,
  UploadButton,
  UploadSection,
} from './styles'
import { domains } from '../../../lib/config'

const columns = [
  {
    title: 'Site ID',
    fieldValue: row => row.siteId,
    sortValue: 'siteId',
  },
  {
    title: 'Site Name',
    fieldValue: row => row.siteName,
    sortValue: 'siteName',
  },
  {
    title: 'Node Friendly Name',
    fieldValue: row => row.nodeFriendlyName,
    sortValue: 'nodeFriendlyName',
  },
  {
    title: 'Start Date',
    fieldValue: row =>
      row.startDate && new Date(row.startDate).toDateString('yyyy-MM-dd'),
  },
  {
    title: 'Error',
    fieldValue: row => row.error,
  },
]

const PacingLayout = props => {
  const {
    file,
    fileName,
    formattedResults,
    handlePacingUpload,
    isLoading,
    onFileChange,
  } = props || {}

  return (
    <React.Fragment>
      <Loading isLoading={isLoading} message="Processing file...." />
      <TitleSection />
      <TemplateLinkWrapper>
        <CsvDownloadLink
          filename={'bulk_pacing_template.csv'}
          data={[{}]}
          headers={csvTemplateHeaders}
          autoClick={false}
        >
          Download Pacing Dates Template
        </CsvDownloadLink>
      </TemplateLinkWrapper>
      <Instructions>
        <InstructionsText />
      </Instructions>
      <FileUpload
        disabled={isLoading}
        fileName={fileName || ''}
        key={fileName}
        onFileChange={onFileChange}
      >
        Browse
      </FileUpload>
      <UploadSection>
        <UploadButton
          color={'#002855'}
          disabled={!file || isLoading}
          onClick={() => handlePacingUpload(file)}
        >
          Upload
        </UploadButton>
      </UploadSection>
      <ResultsSection>
        {formattedResults && (
          <React.Fragment>
            <CsvDownloadLink
              data={formattedResults}
              filename={
                new Date().toISOString() + '_bulk_pacing_dates_results.csv'
              }
              headers={resultsHeaders}
              autoClick={false}
            >
              Click to Download Results
            </CsvDownloadLink>
            <StyledAutoTable
              borderless
              columns={columns}
              headThemeLight
              rows={formattedResults}
            />
          </React.Fragment>
        )}
      </ResultsSection>
      <FieldDescriptions />
      <Instructions>
        All uploaded spreadsheets should be formatted like this:
      </Instructions>
      <ExampleImage
        src={`${domains.CDN_DOMAIN}/assets/img/pacing_preview.png`}
      />
    </React.Fragment>
  )
}

PacingLayout.propTypes = {
  file: PropTypes.object,
  fileName: PropTypes.string,
  handlePacingUpload: PropTypes.func,
  isLoading: PropTypes.bool,
  onFileChange: PropTypes.func,
  uploadResults: PropTypes.array,
}

export default PacingLayout
